import makeValidationSchema from './ProductCondMakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import React, { useEffect, useState, useContext, useCallback } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import FdapnKeys from 'src/constants/locale/key/Fdapn'
import { Card, CardContent, Grid } from '@material-ui/core'
import { FdaPNTranslationContext } from './../contexts/FDAPNTranslationContext.js'
import { useFormContext, useWatch } from 'react-hook-form';
import {
  components,
} from 'cng-web-lib'

const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngSelectField,
      CngTextField,
      CngUomAutocompleteField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  lotNumber: "",
  version: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({
  disabled,
  showNotification,
  parentIdDropdownItems,
  shouldHideMap,
  index
}) {
  const { translate } = useTranslation(Namespace.FDAPN)
  const { getTranslatedText } = useContext(FdaPNTranslationContext)
  const { getValues, setValue, reset, trigger } = useFormContext();

  return (
    <Grid container spacing={2}>
      <CngGridItem xs={12} md={12} shouldHide={shouldHideMap?.lotNumber}>
        <CngTextField
          name={typeof index === 'number' ? `productCond.${index}.lotNumber` : 'lotNumber'}
          label={getTranslatedText('FDAPN', 'productLOTNumber')}
          onChange={(e) => {
            setValue(typeof index === 'number' ? `productCond.${index}.lotNumber` : 'lotNumber', e.target.value.toUpperCase())
          }}
          inputProps={{ maxLength: 25 }}
          size='small'
        />
      </CngGridItem>
    </Grid>
  )
}

const ProductCondFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default ProductCondFormProperties
